module.exports = __webpack_public_path__ + "static/media/banner@768.15342b12.png";